const AVAILABLE_FOR_PRO_PLAN_TOOLTIP_MESSAGE = 'Available for Premium plan only';

export {AVAILABLE_FOR_PRO_PLAN_TOOLTIP_MESSAGE};
